import Vue from 'vue'
import Router from 'vue-router'

import PublicRoutes from '@/routes/public';
import AuthSharedRoutes from '@/routes/authShared';
import AdminRoutes from '@/routes/admin';
import EmployerRoutes from '@/routes/employer';
import CandidateRoutes from '@/routes/candidate';
import HrRoutes from '@/routes/hr';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    ...PublicRoutes,
    ...AuthSharedRoutes,
    ...AdminRoutes,
    ...EmployerRoutes,
    ...CandidateRoutes,
    ...HrRoutes
  ],
  scrollBehavior (to, from) {
    if (from.path === '/jobs/search') {
      return { x: from.x, y: from.y };
    }

    return { x: 0, y: 0 };
  }
})
